import React, {useState} from 'react';
import {route} from "../../../models/route";
import {scrollTo} from "../../../service/ToolsService";
import {NavLink} from "react-router-dom";
import {TableLineLoader} from "../../front/loader/TableLineLoader";
import DateService from "../../../service/DateService";
import {DeleteConfirme} from "../DeleteConfirme";
import {ApiService, filter} from "../../../service/ApiService";
import {useForm} from "react-hook-form";

type FormDataType = {
  rideDate?: string;
  meetPlace?: string;
  circuitId?: string;
}

type RouteListProps = {
  routes: route[],
  loading?: boolean,
  refresh: () => void,
  filter: (f: filter[]) => void,
}

export const RouteList = ({routes, loading, refresh, filter}: RouteListProps) => {
  const [del, setDel] = useState(undefined as undefined | route);

  const deleteRoute = async (route: route) => {
    await ApiService.delete(`/route/${route.routeId}`);
    refresh();
  };

  const {
    register,
    handleSubmit,
  } = useForm<FormDataType>({
    defaultValues: {
      rideDate: undefined,
      meetPlace: undefined,
      circuitId: undefined,
    }
  });

  const onSubmit = async (data: FormDataType) => {
    const filters: filter[] = []

    if ((data.rideDate || undefined) !== undefined) {
      filters.push({
        op: 'eq',
        field: 'rideDate',
        value: `${data.rideDate}`
      })
    }

    if ((data.meetPlace || undefined) !== undefined) {
      filters.push({
        op: 'like',
        field: 'meetPlace',
        value: `*${data.meetPlace}*`
      })
    }

    filter(filters);
  }

  return (
    <>
      <form method="post" onSubmit={handleSubmit(onSubmit)}>
        <table className="table table-responsive table-hover border">
          <thead>
          <tr className="table-primary">
            <th className="w115px">Date</th>
            <th>Rendez-vous</th>
            <th className="w90px text-center">Heure rdv</th>
            <th className="w110px text-center">Heure départ</th>
            <th>Circuit</th>
            <th className="text-center w150px">Modification</th>
            <th className="w200px"></th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>
              <input type="date" className="form-control max-w150px me-3" placeholder="~" {...register('rideDate')} />
            </td>
            <td>
              <input type="text" className="form-control" placeholder="~" {...register('meetPlace')} />
            </td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td className="text-center align-middle">
              <button type="submit" className="btn btn-sm btn-success me-1">ok</button>
            </td>
          </tr>
          {loading && (
            <tr>
              <td colSpan={7} className="pt-4 pb-4 ps-5 pe-5">
                <TableLineLoader/>
              </td>
            </tr>
          )}
          {!loading && routes.map((route: route, i: number) => (
            <tr key={i}>
              <td>
                  {DateService.toLocaleString(route.rideDate, {weekday: 'short', day: '2-digit', month: 'short', year: 'numeric'})}
              </td>
              <td>
                {route.meetPlace}
              </td>
              <td className="text-center">
                {DateService.toLocaleString(route.meetHour, {hour: '2-digit', minute: '2-digit'}).replace(':', 'h')}
              </td>
              <td className="text-center">
                {DateService.toLocaleString(route.startHour, {hour: '2-digit', minute: '2-digit'}).replace(':', 'h')}
              </td>
              <td>{route.circuit?.label}</td>
              <td className="text-center">
                {DateService
                  .toLocaleString(route.updatedAt ?? route.createdAt, {day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false})
                }
              </td>
              <td className="text-end">
                <NavLink to={`/admin/route/route/edit/${route.routeId}`} onClick={scrollTo} className="btn btn-xs btn-primary me-1">
                  <i className="fa-solid fa-pencil me-1"/> modifier
                </NavLink>
                <button className="btn btn-xs btn-danger" onClick={() => setDel(route)}><i className="fa-solid fa-xmark me-1"/>supprimer</button>
              </td>
            </tr>
          ))}
          </tbody>
        </table>
      </form>

      {del && (
        <DeleteConfirme confirme={(c: boolean) => {
          if (c) {
            deleteRoute(del);
          }

          setDel(undefined);
        }}/>
      )}
    </>
  )
}
